import React, { useEffect, useState } from "react";
import { Row, Col, Card, Table, Button, Input, Modal, Typography, Tag, Space, Drawer, Form, Select, notification } from "antd";
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined, PlusOutlined, SearchOutlined, ReloadOutlined } from "@ant-design/icons";
import axios from "axios";
import { baseUrl } from "../../config";

const { confirm } = Modal;
const { Item } = Form;
const { Option } = Select;

function PopPanchayatList() {
  const [form] = Form.useForm();
  const [dataList, setDataList]       = useState([]);
  const [totalCount, setTotalCount]   = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit]       = useState(15);
  const [search, setSearch]           = useState('');
  const [loading, setLoading]         = useState(false);
  const [drawerOpen, setDrawerOpen]   = useState(false);
  const [editId, setEditId]           = useState(null);
  const [saving, setSaving]           = useState(false);

  // Filter state (District → Tehsil)
  const [filterDistricts, setFilterDistricts] = useState([]);
  const [filterTehsils, setFilterTehsils]     = useState([]);
  const [filterDistrict, setFilterDistrict]   = useState('');
  const [filterTehsil, setFilterTehsil]       = useState('');

  // Drawer cascading
  const [countries, setCountries]             = useState([]);
  const [drawerStates, setDrawerStates]       = useState([]);
  const [drawerDistricts, setDrawerDistricts] = useState([]);
  const [drawerTehsils, setDrawerTehsils]     = useState([]);

  const authHeader = { Authorization: `Bearer ${localStorage.getItem('accessToken')}` };

  useEffect(() => {
    // Load districts for filter bar
    axios.get(`${baseUrl}/pop-districts/list-all`, { headers: authHeader })
      .then(r => { if (r.data.status) setFilterDistricts(r.data.result); });
    // Load countries for drawer
    axios.get(`${baseUrl}/pop-country/list-all`, { headers: authHeader })
      .then(r => { if (r.data.status) setCountries(r.data.result); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchList = (page = currentPage, q = search, districtId = filterDistrict, tehsilId = filterTehsil) => {
    setLoading(true);
    const params = { page, limit, search: q };
    if (districtId) params.district_id = districtId;
    if (tehsilId)   params.tehsil_id   = tehsilId;
    axios.get(`${baseUrl}/pop-panchayat`, { headers: authHeader, params })
      .then(r => {
        if (r.data.status) {
          setDataList(r.data.result.map((item, i) => ({ ...item, key: (page - 1) * limit + i + 1 })));
          setTotalCount(r.data.totalCount);
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchList(); }, [currentPage]); // eslint-disable-line

  const onFilterDistrictChange = (v) => {
    setFilterDistrict(v || '');
    setFilterTehsil('');
    setFilterTehsils([]);
    setCurrentPage(1);
    fetchList(1, search, v || '', '');
    if (v) {
      axios.get(`${baseUrl}/pop-tehsils/list-all`, { headers: authHeader, params: { district_id: v } })
        .then(r => { if (r.data.status) setFilterTehsils(r.data.result); });
    }
  };

  const onFilterTehsilChange = (v) => {
    setFilterTehsil(v || '');
    setCurrentPage(1);
    fetchList(1, search, filterDistrict, v || '');
  };

  const handleReset = () => {
    setFilterDistrict(''); setFilterTehsil(''); setFilterTehsils([]);
    setSearch(''); setCurrentPage(1);
    fetchList(1, '', '', '');
  };

  // Drawer helpers
  const onDrawerCountryChange = (v) => {
    form.setFieldsValue({ state_id: undefined, district_id: undefined, tehsil_id: undefined });
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]);
    if (v) axios.get(`${baseUrl}/pop-states/list-all`, { headers: authHeader, params: { country_id: v } })
      .then(r => { if (r.data.status) setDrawerStates(r.data.result); });
  };
  const onDrawerStateChange = (v) => {
    form.setFieldsValue({ district_id: undefined, tehsil_id: undefined });
    setDrawerDistricts([]); setDrawerTehsils([]);
    if (v) axios.get(`${baseUrl}/pop-districts/list-all`, { headers: authHeader, params: { state_id: v } })
      .then(r => { if (r.data.status) setDrawerDistricts(r.data.result); });
  };
  const onDrawerDistrictChange = (v) => {
    form.setFieldsValue({ tehsil_id: undefined });
    setDrawerTehsils([]);
    if (v) axios.get(`${baseUrl}/pop-tehsils/list-all`, { headers: authHeader, params: { district_id: v } })
      .then(r => { if (r.data.status) setDrawerTehsils(r.data.result); });
  };

  const openAdd = () => {
    form.resetFields(); form.setFieldsValue({ status: '1' });
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]);
    setEditId(null); setDrawerOpen(true);
  };

  const openEdit = async (r) => {
    setDrawerStates([]); setDrawerDistricts([]); setDrawerTehsils([]);
    setEditId(r.id); setDrawerOpen(true);
    if (r.country_id) { const res = await axios.get(`${baseUrl}/pop-states/list-all`, { headers: authHeader, params: { country_id: r.country_id } }); if (res.data.status) setDrawerStates(res.data.result); }
    if (r.state_id)   { const res = await axios.get(`${baseUrl}/pop-districts/list-all`, { headers: authHeader, params: { state_id: r.state_id } }); if (res.data.status) setDrawerDistricts(res.data.result); }
    if (r.district_id){ const res = await axios.get(`${baseUrl}/pop-tehsils/list-all`, { headers: authHeader, params: { district_id: r.district_id } }); if (res.data.status) setDrawerTehsils(res.data.result); }
    form.setFieldsValue({
      country_id:  r.country_id  ? parseInt(r.country_id)  : undefined,
      state_id:    r.state_id    ? parseInt(r.state_id)    : undefined,
      district_id: r.district_id ? parseInt(r.district_id) : undefined,
      tehsil_id:   r.tehsil_id   ? parseInt(r.tehsil_id)   : undefined,
      name: r.name, status: String(r.status),
    });
  };

  const onSave = async (values) => {
    setSaving(true);
    try {
      if (editId) await axios.put(`${baseUrl}/pop-panchayat/${editId}`, values, { headers: authHeader });
      else        await axios.post(`${baseUrl}/pop-panchayat`, values, { headers: authHeader });
      notification.success({ message: editId ? 'Panchayat updated' : 'Panchayat added' });
      setDrawerOpen(false); fetchList();
    } catch (e) {
      notification.error({ message: e.response?.data?.message || 'Error' });
    } finally { setSaving(false); }
  };

  const handleDelete = (id) => confirm({
    title: 'Delete this panchayat?', icon: <ExclamationCircleOutlined />,
    okText: 'Yes, Delete', okType: 'danger', cancelText: 'Cancel',
    onOk: async () => {
      await axios.delete(`${baseUrl}/pop-panchayat/${id}`, { headers: authHeader });
      notification.success({ message: 'Deleted' }); fetchList();
    },
  });

  const columns = [
    { title: '#', dataIndex: 'key', key: 'key', width: 60 },
    { title: 'Panchayat Name', dataIndex: 'name', key: 'name' },
    { title: 'Tehsil', dataIndex: 'tehsil_name', key: 'tehsil_name' },
    { title: 'District', dataIndex: 'district_name', key: 'district_name' },
    { title: 'Status', dataIndex: 'status', key: 'status', width: 90,
      render: s => <Tag color={String(s) === '1' ? 'green' : 'red'}>{String(s) === '1' ? 'Active' : 'Inactive'}</Tag> },
    { title: 'Actions', key: 'actions', fixed: 'right', width: 140,
      render: (_, record) => (
        <Space size={4}>
          <Button size="small" icon={<EditOutlined />} onClick={() => openEdit(record)}
            style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Edit</Button>
          <Button size="small" danger icon={<DeleteOutlined />} onClick={() => handleDelete(record.id)}>Delete</Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <Card
            title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Panchayats <Tag color="cyan">{totalCount}</Tag></span>}
            headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' }}
            extra={
              <Button icon={<PlusOutlined />} onClick={openAdd}
                style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', fontWeight: 600 }}>
                Add Panchayat
              </Button>
            }
          >
            {/* ── Filter Bar ── */}
            <div style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '12px 16px', marginBottom: 16 }}>
              <Space wrap size={10}>
                <Select placeholder="Filter by District" style={{ width: 190 }} allowClear showSearch optionFilterProp="children"
                  value={filterDistrict || undefined} onChange={onFilterDistrictChange}>
                  {filterDistricts.map(d => <Option key={d.id} value={String(d.id)}>{d.name}</Option>)}
                </Select>

                <Select placeholder="Filter by Tehsil" style={{ width: 180 }} allowClear showSearch optionFilterProp="children"
                  value={filterTehsil || undefined} onChange={onFilterTehsilChange}
                  disabled={!filterDistrict && filterTehsils.length === 0}>
                  {filterTehsils.map(t => <Option key={t.id} value={String(t.id)}>{t.name}</Option>)}
                </Select>

                <Input.Search
                  placeholder="Search panchayat name..."
                  value={search}
                  onChange={e => setSearch(e.target.value)}
                  onSearch={val => { setSearch(val); setCurrentPage(1); fetchList(1, val, filterDistrict, filterTehsil); }}
                  allowClear style={{ width: 240 }}
                  enterButton={<Button icon={<SearchOutlined />} style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Search</Button>}
                />

                <Button icon={<ReloadOutlined />} onClick={handleReset}>Reset</Button>
              </Space>
            </div>

            <Table
              columns={columns} dataSource={dataList} loading={loading} size="small"
              scroll={{ x: 'max-content' }}
              pagination={{ current: currentPage, pageSize: limit, total: totalCount, onChange: p => setCurrentPage(p), showTotal: t => `Total ${t} panchayats`, showSizeChanger: false }}
            />
          </Card>
        </Col>
      </Row>

      <Drawer
        title={<span style={{ fontWeight: 700, color: '#1e293b' }}>{editId ? 'Edit Panchayat' : 'Add Panchayat'}</span>}
        width={540} open={drawerOpen} onClose={() => setDrawerOpen(false)} bodyStyle={{ paddingBottom: 80 }}
        footer={
          <Space>
            <Button loading={saving} onClick={() => form.submit()}
              style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff' }}>Save</Button>
            <Button onClick={() => setDrawerOpen(false)}>Cancel</Button>
          </Space>
        }
      >
        <Form form={form} layout="vertical" onFinish={onSave}>
          <Item name="country_id" label="Country" rules={[{ required: true, message: 'Required' }]}>
            <Select placeholder="Select Country" showSearch optionFilterProp="children" onChange={onDrawerCountryChange} style={{ width: '100%' }}>
              {countries.map(c => <Option key={c.id} value={c.id}>{c.name}</Option>)}
            </Select>
          </Item>
          <Item name="state_id" label="State" rules={[{ required: true, message: 'Required' }]}>
            <Select placeholder="Select State" showSearch optionFilterProp="children" onChange={onDrawerStateChange} disabled={drawerStates.length === 0} style={{ width: '100%' }}>
              {drawerStates.map(s => <Option key={s.id} value={s.id}>{s.name}</Option>)}
            </Select>
          </Item>
          <Item name="district_id" label="District" rules={[{ required: true, message: 'Required' }]}>
            <Select placeholder="Select District" showSearch optionFilterProp="children" onChange={onDrawerDistrictChange} disabled={drawerDistricts.length === 0} style={{ width: '100%' }}>
              {drawerDistricts.map(d => <Option key={d.id} value={d.id}>{d.name}</Option>)}
            </Select>
          </Item>
          <Item name="tehsil_id" label="Tehsil" rules={[{ required: true, message: 'Required' }]}>
            <Select placeholder="Select Tehsil" showSearch optionFilterProp="children" disabled={drawerTehsils.length === 0} style={{ width: '100%' }}>
              {drawerTehsils.map(t => <Option key={t.id} value={t.id}>{t.name}</Option>)}
            </Select>
          </Item>
          <Item name="name" label="Panchayat Name" rules={[{ required: true, message: 'Required' }]}>
            <Input placeholder="Enter panchayat name" />
          </Item>
          <Item name="status" label="Status">
            <Select><Option value="1">Active</Option><Option value="0">Inactive</Option></Select>
          </Item>
        </Form>
      </Drawer>
    </div>
  );
}

export default PopPanchayatList;
